import { Component, OnInit, OnDestroy, HostBinding, ViewChild } from '@angular/core';
import { NgbModalRef, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { ResultsPopupEditorDialogService, PopupEditorParams } from './results-popup-editor-dialog-service';
import { SLLayer } from 'src/app/model/sl-layer';
import { AnyHandler } from 'src/app/types/@types/sl-v-types';
import { ResultsPopupEditorComponent, PopupChanges } from '../../results-popup-editor/results-popup-editor.component';
import { LayerApiService } from 'src/app/model/api-services/layer-api.service';
import { ModalMessagerService } from 'src/app/modal-messager/modal-messager.service';

@Component({
	selector: 'app-results-popup-editor-dialog',
	templateUrl: './results-popup-editor-dialog.component.html',
	styleUrls: ['./results-popup-editor-dialog.component.scss']
})
export class ResultsPopupEditorDialogComponent implements OnInit {

	public title = 'Results Popup Text Editor';
	public value: PopupChanges = { tool: '', popup: '' };

	private layer: SLLayer;
	private handler: AnyHandler;

	@HostBinding('class.work-view') workView = true;
	@HostBinding('class.layer-edit') hasEditAccess = false;
	@HostBinding('class.layer-read') hasReadAccess = false;
	@HostBinding('class.layer-read-only') hasReadOnlyAccess = false;
	@ViewChild('editor', { static: true }) editor: ResultsPopupEditorComponent;
	constructor(private layerSvc: LayerApiService, private activeModal: NgbActiveModal, private messager: ModalMessagerService) { }

	ngOnInit() {
	}
	Show(params: PopupEditorParams) {
		this.layer = params.layer;
		if (Number(this.layer.access) === 1) {
			this.hasReadOnlyAccess = true;
			this.hasReadAccess = true;
		}
		if (Number(this.layer.access) > 1) {
			this.hasReadOnlyAccess = false;
			this.hasReadAccess = true;
			this.hasEditAccess  = true;
		}
		this.handler = params.handler;
		this.editor.SetLayer(this.layer);
	}
	Apply() {
		this.layer.tooltip = this.value.tool;
		this.layer.richTooltip = this.value.popup;
		this.messager.Notify('Changes have been applied', false, 'The changes you made have been applied for the current layer. These changes are not permanent and will be reset if you reload the map.');
	}
	Save() {
		this.layer.tooltip = this.value.tool;
		this.layer.richTooltip = this.value.popup;
		this.messager.Progress('Sending Hover Text and Popup Text to server', false, .5, 'Submitting data ...');
		this.layerSvc.SaveLayer(this.layer, { rich_tooltip: this.value.popup, tooltip: this.value.tool }, false).then((result) => {
			this.messager.Progress('Save complete', true, 1, 'Submitting data ...');
		});
	}
	SaveAsDefault() {
		this.messager.Progress('Sending Hover Text and Popup Text to server as layer default', false, .5, 'Submitting default data ...');
		this.layerSvc.SaveLayer(this.layer, { rich_tooltip: this.value.popup, tooltip: this.value.tool }, true).then((result) => {
			this.messager.Progress('Save complete', false, 1, 'Submitting default data ...');
		});
	}
	Revert() {
		this.editor.SetLayer(this.layer);
	}
	LoadDefault() {
		this.layerSvc.LoadLayer(this.layer, { target: 'layer', tooltip_rich: true, tooltip: true }).then((result) => {
			if (!!result.response.layer) {
				this.layer.richTooltip = result.response.layer.rich_tooltip;
				this.layer.tooltip = result.response.layer.tooltip.value;
				this.editor.SetLayer(this.layer);
			}

		});
	}
	Cancel() {
		this.activeModal.close();
	}

}


@Component({
	selector: 'app-results-popup-editor-dialog-entry',
	template: ''
})
export class ResultsPopupEditorDialogEntryComponent implements OnDestroy {
	modalRef: NgbModalRef;
	subscriptionMgr: SubScriptionMgr = new SubScriptionMgr();
	lastTitle: string | null = null;

	constructor(private modalService: NgbModal, private service: ResultsPopupEditorDialogService) {

		this.subscriptionMgr.Subscribe(service.request$, (info: any) => {
			this.modalRef = this.modalService.open(ResultsPopupEditorDialogComponent, { backdrop: 'static' });
			(this.modalRef.componentInstance as ResultsPopupEditorDialogComponent).Show(info);
		});
	}
	ngOnDestroy(): void {
		this.subscriptionMgr.CancelSubscriptions();
	}
}
